/* countdown.js */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-countdown]").forEach(el => {
    const target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;

    const days = el.querySelector("[data-cd-days]");
    const hours = el.querySelector("[data-cd-hours]");
    const mins = el.querySelector("[data-cd-mins]");
    const secs = el.querySelector("[data-cd-secs]");

    function tick() {
      const diff = target - Date.now();
      if (diff <= 0) {
        el.innerHTML = `<span>Offer ended</span>`;
        clearInterval(timer);
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      days.textContent = String(d).padStart(2, "0");
      hours.textContent = String(h).padStart(2, "0");
      mins.textContent = String(m).padStart(2, "0");
      secs.textContent = String(s).padStart(2, "0");
    }

    tick();
    const timer = setInterval(tick, 1000);
  });
});
